/**已失效**/
<template>
  <div class="stale">
    <div class="staleContent">
      <div v-if="couponsFn&&couponsFn.length">
        <xk-couponMod v-for="(item, index) in couponsFn"
                      :type="item.type"
                      :sum="item.sum"
                      :title="item.title"
                      :startTime="item.startTime"
                      :key="index"
                      :endTime="item.endTime"
                      :overdueTime="item.overdueTime"
                      :couponType="item.couponType"
                      :status="1"
                      :useState="3"
                      :serviceType="item.serviceType"
        ></xk-couponMod>
        <!--<div class="loadMoreBut" @click="loadMoreButFn"-->
             <!--v-if="couponData&&couponData.length<total">-->
          <!--<span>点击加载更多</span>-->
        <!--</div>-->
      </div>
      <div v-else="" class="shixiao">
        <h2>
          暂无失效优惠券记录
        </h2>
      </div>
    </div>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Toucth from '../../../assets/js/method'
  import XkHintBox from '../../module/hintBox/src/hintBox'

  export default {
    name: '',
    components: {
      XkHintBox
    },
    computed: {
      ...mapGetters({
        expireCoupons: 'expireCoupons',
        expireCouponGetter: 'expireCouponGetter',
        loginData: 'loginData'
      }),
      couponsFn: function () {
        let that = this
        let content = that.expireCouponGetter
        let list = []
        for (let i = 0; i < content.length; i++) {
          let obj = {
            type: 'daijia',
            title: '代驾专享',
            sum: 30,
            startTime: '2017-03-05',
            endTime: '2017-06-06',
            couponType: 'money',
            serviceType: ''
          }
          // switch (content[i].couponType) {
          //   case 1:
          //     obj.type = 'daijia'
          //     break
          //   case 'zhuanche':
          //     obj.type = 'zhuanche'
          //     break
          //   case 'paotui':
          //     obj.type = 'paotui'
          //     break
          //   case 'freight':
          //     obj.type = 'huoyun'
          //     break
          //   case 'xiche':
          //     obj.type = 'xiche'
          //     break
          //   case 'pinche':
          //     obj.type = 'pinche'
          //     break
          //   case 'zhuanxian':
          //     obj.type = 'zhuanxian'
          //     break
          //   case 'gasstation':
          //     obj.type = 'gasstation'
          //     break
          // }
          obj.title = content[i].title
          obj.startTime = Toucth.TimestampDate(content[i].begin_time).split(' ')[0]
          obj.endTime = Toucth.TimestampDate(content[i].end_time).split(' ')[0].indexOf('1970-01-01') < 0 ? Toucth.TimestampDate(content[i].end_time).split(' ')[0] : '永久有效'
          obj.sum = content[i].deductible ? content[i].deductible.toFixed(1) : content[i].discount / 10
          if (content[i].discount) {
            obj.couponType = 'discount'
          } else {
            obj.couponType = 'deduction'
          }
          if (content[i].main_service_type === 'daijia') {
            obj.serviceType = '代驾券'
          }
          list.push(obj)
        }
        return list
      }
    },
    data () {
      return {
        page: 1,
        rows: 10,
        couponData: [],
        total: 0,
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        }
      }
    },
    methods: {
      loadMoreButFn: function () {
        let that = this
        that.page += 1
        that.$store.dispatch('getCouponType', {
          channel: 'system',
          page: that.page,
          limit: 80,
          'fn': (data) => {
            that.loadState = false
            if (data && data.code === 1) {
              that.total = data.total
              let arr = []
              if (data.coupon) {
                data.coupon.forEach(item => {
                  if (item.state === 3) {
                    // var endTime = item.end_time
                    // if (endTime) {
                    //   if (new Date().valueOf() < endTime * 1000) {
                    //     arr.push(item)
                    //   }
                    // } else {
                    //   arr.push(item)
                    // }
                    arr.push(item)
                  }
                })
                that.couponData = that.couponData.concat(...arr)
              } else {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: '没有更多优惠券了喔~'
                }
                setTimeout(function () {
                  that.hintBox.stateShow = false
                }, 1000)
              }
            }
          }
        })
      },
      getCoupons: function () {
        let that = this
        that.$store.dispatch('checkLogin', (state) => {
          if (state) {
            that.$store.dispatch('getCouponType', {
              channel: 'system',
              page: that.page,
              limit: 80,
              'fn': (data) => {
                that.loadState = false
                if (data && data.code === 1) {
                  that.total = data.total
                  let arr = []
                  data.coupon.forEach(item => {
                    if (item.state === 3) {
                      // var endTime = item.end_time
                      // if (endTime) {
                      //   if (new Date().valueOf() < endTime * 1000) {
                      //     arr.push(item)
                      //   }
                      // } else {
                      //   arr.push(item)
                      // }
                      arr.push(item)
                    }
                  })
                  that.couponData = that.couponData.concat(...arr)
                }
              }
            })
          }
        })
      }
    },
    mounted: function () {
      this.loadState = true
      this.getCoupons()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .stale {
    box-sizing: border-box;
    padding: 0 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    .shixiao {
      height: 40vh;
      padding-top: 30vh;
      h2 {
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// stale.vue?ebe0ddc2